import 'bootstrap-italia';

import { Search } from "./components/search/search";


document.addEventListener('DOMContentLoaded', function() {
	document.querySelector('body').classList.add('loaded');

	if ( document.querySelector('.accordion') ) {
		import('./components/accordion/accordion').then(c => {
			document.querySelectorAll('.accordion').forEach( (accordion: HTMLElement) => new c.Accordion(accordion) );
		});
	}

	if ( document.querySelector('.members-filters') ) {
		import('./components/member-filters/member-filters').then(c => new c.MemberFilters() );
	}

	if ( document.querySelector('.downloads-container__nav-vertical') ) {
		import('./components/downloads/downloads').then(c => new c.Downloads() );
	}

	if ( document.querySelector('.card') ) {
		import('./components/card-links/card-links').then(c => new c.CardLinks() );
	}

	const s = new Search();

	document.addEventListener('wpcf7submit', (event) => {
		document.getElementsByClassName('wpcf7-response-output')[0].scrollIntoView({ behavior: 'smooth', block: 'center'})
	}, false);

});




